var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDistanceTool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.751 5.442a.848.848 0 0 0 0-1.2l-1.992-1.993a.848.848 0 0 0-1.2 0L15 3.807 18.193 7l1.558-1.558zM5 13.962V17h3.038L17 8.038 13.961 5 5 13.961zm-.018 5.303a1.5 1.5 0 1 0-.305 1.166l10.371 1.448a1.5 1.5 0 1 0 2.284-1.628l2.352-4.262a1.5 1.5 0 1 0-1.016-.24l-2.352 4.262a1.5 1.5 0 0 0-1.083.686L4.982 19.265zM16.5 22a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm3.5-7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistanceTool);
export default __webpack_public_path__ + "static/media/icon_distance_tool.0fc68a1c473d93db615f9d1775fc6dd8.svg";
export { ForwardRef as ReactComponent };